import { render, staticRenderFns } from "./AulaFormFooter.vue?vue&type=template&id=35fa7f50&scoped=true&"
import script from "./AulaFormFooter.vue?vue&type=script&lang=js&"
export * from "./AulaFormFooter.vue?vue&type=script&lang=js&"
import style0 from "./AulaFormFooter.vue?vue&type=style&index=0&id=35fa7f50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fa7f50",
  null
  
)

export default component.exports